//==========import components===============
import TitleSection from './TitleSection';

const OurPartner = ({ data, titleDetail }) => {
  return (
    <section className='DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <div className='DBlock'>
          <div className='max-w-6xl mx-auto grid sm:grid-cols-5 grid-cols-3 gap-y-1 gap-x-4 place-items-center'>
            {data?.map((list) => (
              <div key={`partnerKey${list?.id}`}>
                <img width='80%' src={list?.image} alt='partnerImg' />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPartner;
